'use client';

import { useId } from 'react';
import {
  RiBookmark3Line,
  RiFileExcel2Line,
  RiGlobalLine,
  RiMegaphoneLine,
  RiPaletteLine,
  RiPlugLine,
} from '@remixicon/react';
import { useTranslations } from 'next-intl';

import { ProductSection, SectionHead } from '@/components/product-section';
import { hl } from '@/lib/rich-text';

/**
 * "Bir sohbet kutusundan fazlası" — ajanın soru-cevap dışındaki işleri.
 *
 * Yalnız doğrulanmış yetenekler (14 Eki 2026 ürün dökümü, FAZ9 matrisi):
 * web araması + sayfa okuma (kaynak satırıyla), kod çalıştırma + dosya
 * (xlsx/pptx/docx/pdf → `file` kartı), brief motoruyla kampanya kurma (hepsi
 * DURAKLATILMIŞ), kreatif işi + sohbette canlı kart, MCP bağlayıcıları (kurulum
 * yönetici, yazma varsayılan kapalı), bellek aracı.
 * Adı geçen MCP hazırlarından OAuth'u doğrulanmamış olanlar (Slack, Asana,
 * Google Drive, HubSpot) metinde anılmıyor.
 *
 * Bölüm AgentAsks'in hemen altında: "ne sorabilirim"den sonra doğan soru
 * "peki başka ne yapar".
 */

const ITEMS = [
  { key: 'web', Icon: RiGlobalLine },
  { key: 'files', Icon: RiFileExcel2Line },
  { key: 'build', Icon: RiMegaphoneLine },
  { key: 'create', Icon: RiPaletteLine },
  { key: 'tools', Icon: RiPlugLine },
  { key: 'memory', Icon: RiBookmark3Line },
] as const;

export function AgentMore() {
  const t = useTranslations('featuresAgent.more');
  const uid = useId();

  return (
    <ProductSection tone="white" labelledBy={`${uid}-title`}>
      <SectionHead
        id={`${uid}-title`}
        eyebrow={t('eyebrow')}
        title={t.rich('title', { hl })}
        lead={t('lead')}
      />

      <ul className="ps-facts">
        {ITEMS.map(({ key, Icon }) => (
          <li key={key} className="ps-fact">
            <Icon className="ps-fact-icon" size={20} aria-hidden="true" />
            <p className="ps-fact-title">{t(`items.${key}.title`)}</p>
            <p className="ps-fact-text">{t(`items.${key}.text`)}</p>
          </li>
        ))}
      </ul>
    </ProductSection>
  );
}
